<template>
  <div class="overall-bg">
    <b-container>
      <b-row class="py-5">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading" class="table-width-80">
              <MasterEmpty v-if="items.length === 0" eheader="Rate Contract" econtent="Rate Contract"
                eimg="/src/assets/Img/icons/sub-tax.svg" @createNew="IsCreate" />
              <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading"
                responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                :exceldownload="true">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Rate Contract" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:action="{ data }">
                  <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                    @click="toggle($event, data)" />
                  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
                  <!-- <EditIcon @click="IsConfirmEdit(data)" />
            
              <DeleteIcon @click="IsConfirmDel(data)"></DeleteIcon> -->
                  <!-- </span> -->
                </template>
              </Tableview>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="items.length === 0" eheader="Rate Contract" econtent="Rate Contract"
                eimg="/src/assets/Img/icons/sub-tax.svg" @createNew="IsCreate" />
              <MobileViewCardHeader v-if="items.length !== 0">
                <template v-slot:mobilecard> </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="Isdelete()" @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import RateContractService from "../../../../../modules/Inventory/Service/RateContractService";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import DeleteIcon from "../../../../../components/GeneralButtons/DeleteIcon.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import ExportOption from "../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    EditConfirmation,
    DeletedSuccessfully,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,
    Tableview,
    Loader,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    MasterEmpty,
    ExportOption,
  },

  setup() {
    const showDialog = ref(false);
    const dataEdit = ref(0);
    const dataDelete = ref(0);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const editItems = ref();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      IsShow();
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const router = useRouter();
    const route = useRoute();

    //Table data
    let items = ref([]);
    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data.Id;
      Editmodel.value = true;
    }
    const contentdel = ref("");
    function IsConfirmDel(data, Status) {
      debugger;
      data.ActiveStatus = Status;
      dataEdit.value = data;
      Editmodel.value = false;
      if (Status == 1) {
        contentdel.value = "Activate?";
      } else if (Status == 2) {
        contentdel.value = "InActivate?";
      } else {
        contentdel.value = "Delete?";
      }
      Deletemodel.value = true;
    }

    //Table column List
    const headers = [
      {
        header: t('storetabdetails.ratecontracttableview.SNo'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('storetabdetails.ratecontracttableview.SupplierName'),
        field: "SupplierName",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.ratecontracttableview.ItemCount'),
        field: "ItemCount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
      // {
      //   header: "From Date",
      //   field: "FromDate",
      // },
      // {
      //   header: "To Date",
      //   field: "ToDate",
      // },
      // { field: "action", header: "", slot: "action",
      // frozencolumn: true, sortable: false },
    ];

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await RateContractService.getdata(route.query.Id);


        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }


    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
      router.push({
        path: "/RateContractCreation",
        query: {
          Id: data,
          StoreId: route.query.Id,
          StoreBrMapId: route.query.storebranchmapid,
          BranchId: route.query.BranchId,

        },
      });
    }

    //IsShow function
    const IsShow = async () => {
      debugger;
      try {
        debugger;
        loading.value = true;
        const response = await RateContractService.getdata(route.query.Id);
        items.value = response["result"];
        console.log(items.value);

        loading.value = false;
      } catch (error) {
        alert(error);
      }
    };

    //categorydelete function
    const Isdelete = async () => {
      debugger;
      loading.value = true;
      try {
        const response = await RateContractService.deletedata(
          dataEdit.value["Id"]
        );
        let message = response["ErrorInfo"].ErrorCode;
        console.log(response);
        loading.value = false;
        if (message == null) {
          deletepop.value = true;
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    //Create Function
    function IsCreate() {
      router.push({
        path: "/RateContractCreation",
        query: {
          Id: 0,
          StoreId: route.query.Id,
          StoreBrMapId: route.query.storebranchmapid,
          BranchId: route.query.BranchId,

        },
      });
    }

    let loading = ref(false);

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));
    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();

    let Activevisible = ref();
    let Deletevisible = ref();
    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;
      if (data.Status == 2) {
        InActivevisible.value = false;
        Activevisible.value = true;
        Editvisible.value = false;
      } else {
        InActivevisible.value = true;
        Activevisible.value = false;
        Editvisible.value = true;
      }
      menu.value.toggle(event);
    };
    const menu = ref();
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },
        ],
      },
    ]);

    return {
      itemListed,
      menu,
      contentdel,
      toggle,
      deletepop,
      Deletemodel,
      closetrigger,
      IsConfirmEdit,
      IsConfirmDel,
      IsEdit,
      dataEdit,
      dataDelete,
      Editmodel,
      IsCreate,
      Isdelete,
      headers,
      items,
      filters,
      globalFilterFields,
      filteredColumns,
      loading,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
